<template>
  <div>
    <div v-if="question.InterfaceKey !== 'CoverType'">
      <HomeBaseLabel :question="question" />
      <v-radio-group
        row
        hide-details="auto"
        class="mt-n8 ml-n8 radioImage"
        v-model="question.Value"
        :rules="getRules"
      >
        <v-card
          :ripple="true"
          class="elevation-0 mt-8 ml-8"
          :class="{ 'radioImage--active': question.Value === option.Value }"
          v-for="(option, index) in question.Options"
          :key="index"
          @click="getValue(option.Value)"
        >
          <div class="radioImage__outer">
            <div class="radioImage__inner">
              <v-img
                :src="require(`@/assets/icons/${option.Image.Path}`)"
                :width="option.Image.MaxWidth"
                :height="option.Image.MaxHeight"
                :alt="option.Image.ImageName"
              ></v-img>
              <label class="font-weight-bold">{{ option.Text }}</label>
            </div>
          </div>
        </v-card>
      </v-radio-group>
    </div>
    <div v-else>
      <div
        class="d-flex flex-column align-center white rounded-lg elevation-3 pa-md-15 pa-sm-4 mx-2"
      >
        <BaseButton
          v-if="showBackToFactFindButton"
          text="Back to 'Fact find'"
          flat
          ripple
          class="font-weight-bold mt-2 d-flex back-btn align-self-start"
          icon="mdi-chevron-left"
          color="accent"
          small
          @click="handleBackToFactFind"
        />
        <h1
          class="mt-14 mb-13 text-center text-sm-h5 font-weight-bold text-md-h4 text--title"
        >
          {{ question.Text }}
        </h1>
        <v-form class="align-self-stretch" ref="quotationQuestionsForm">
          <div class="d-flex flex-column align-center">
            <v-radio-group
              row
              hide-details="auto"
              class="radioImage radio__wrapper mt-0 pt-0"
              :data-uiid="question.DataUiid"
              v-model="question.Value"
              :rules="getRules"
            >
              <v-card
                :ripple="false"
                class="elevation-0"
                :class="[
                  question.Value === option.Value ? 'radioImage--active' : '',
                ]"
                :data-uiid="option.DataUiid"
                v-for="(option, index) in question.Options"
                :key="index"
                @click="getValue(option.Value)"
                :aria-label="option.Text"
              >
                <div class="radioImage__outer">
                  <div class="radioImage__inner">
                    <div class="img__wrapper">
                      <v-img
                        :src="require(`@/assets/icons/${option.Image.Path}`)"
                        :max-width="option.Image.MaxWidth"
                        :max-height="option.Image.MaxHeight"
                        :alt="option.Image.ImageName"
                        class="coverIcons"
                      ></v-img>
                    </div>
                    <label
                      class="font-weight-bold"
                      :class="
                        $vuetify.breakpoint.lgAndUp ? 'font-24' : 'font-16'
                      "
                      v-html="option.Text"
                    ></label>
                  </div>
                </div>
              </v-card>
            </v-radio-group>
            <!--Help text-->
            <div v-if="question.DialogComponentName" class="cover-help-block">
              <span
                class="d-flex"
                :class="[
                  $vuetify.breakpoint.lgAndUp ? 'align-center' : 'align-start',
                ]"
              >
                <div class="cover-help-icon__wrapper">
                  <v-icon
                    color="#106175"
                    :size="18"
                    class="mr-1 text-cursor"
                    @click="showModal(question?.DialogComponentName)"
                    >mdi-help-circle</v-icon
                  >
                </div>
                <a
                  @click="showModal(question?.DialogComponentName)"
                  :aria-label="question.HelpText"
                >
                  <span>{{ question.HelpText }}</span></a
                >
              </span>
            </div>
            <v-btn
              :ripple="false"
              depressed
              color="mustard"
              class="mt-9 mt-md-13 font-weight-bold font-20 text-uppercase continueBtn"
              rounded
              x-large
              @click="handleContinue"
              :loading="isLoadingContinue"
              aria-label="Continue"
              >Continue</v-btn
            >
          </div>
        </v-form>
      </div>
    </div>
  </div>
</template>

<script>
import QuestionValidation from "@/Mixins/Validation/QuestionValidation";
import { isQuilterSpecific } from "@/common/question-set";
import BaseButton from "@/components/BaseComponents/BaseButton";
import HomeBaseLabel from "@/components/HomeComponents/HomeBaseComponents/HomeBaseLabel";
import {
  DIALOG_MODULE,
  QUESTIONS_MODULE,
  STEPS_MODULE,
} from "@/store/types/module-types";
import { mapActions, mapGetters, mapMutations } from "vuex";

export default {
  name: "RadioImageToggleHiddenQuestion",
  components: {
    HomeBaseLabel,
    BaseButton,
  },
  data() {
    return {
      isLoadingContinue: false,
    };
  },
  mixins: [QuestionValidation],
  props: {
    question: {
      type: Object,
      required: true,
    },
  },
  watch: {
    "question.Value"() {
      this.setQuestionVisibility(this.question);
    },
  },
  computed: {
    ...mapGetters(QUESTIONS_MODULE, [
      "qsId",
      "isExpired",
      "replacementProductAvailable",
    ]),
    showBackToFactFindButton() {
      return isQuilterSpecific(this.qsId);
    },
  },
  methods: {
    ...mapActions(QUESTIONS_MODULE, [
      "setQuestionVisibility",
      "createTransferQuote",
    ]),
    ...mapActions(STEPS_MODULE, ["handleResetSteps"]),
    ...mapMutations(DIALOG_MODULE, ["showModal"]),
    getValue(value) {
      this.question.Value = value;
    },
    async handleContinue() {
      this.isLoadingContinue = true;
      if (this.$refs.quotationQuestionsForm.validate()) {
        if (this.isExpired && this.replacementProductAvailable) {
          await this.createTransferQuote({
            isCreateQuoteFromTransferDialog: false,
            isPartialQuote: true,
            router: this.$router,
          });
          return;
        }
        this.$router.push("/quotation");
        this.handleResetSteps();
        return;
      }
      this.isLoadingContinue = false;
    },
    handleBackToFactFind() {
      this.$router.push("/factfind");
    },
  },
};
</script>

<style lang="scss" scoped>
.rounded-lg.elevation-3 {
  margin-top: 24px !important;
  margin-bottom: 80px !important;
}
.radioImage.radio__wrapper {
  .v-card {
    min-height: 216px !important;
    min-width: 204px !important;
    position: relative !important;
    border-radius: 13.5px;
    border: solid 1px $stepper-inactive !important;
    transition: border-width 0.1s linear;
    &.radioImage--active {
      border: solid 4px $cyan-darken-4 !important;
    }
  }
  :deep(.v-input--radio-group__input) {
    gap: 14px;
    justify-content: center;
  }
  .img__wrapper {
    min-height: 73px;
    margin-bottom: 19px;
    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;
  }
}
.text--title.text-md-h4 {
  font-size: 32px !important;
  color: $black-2;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal !important;
  text-align: left;
}
.continueBtn {
  max-width: 440px;
  width: 100%;
  height: 60px !important;
  margin-bottom: 126px !important;
}
.back-btn {
  margin-top: -21px !important;
  margin-left: -46px !important;
  margin-bottom: 25px !important;
}
.cover-help-block {
  padding-top: 38px;
  text-align: center;
  margin-bottom: -5px; // override continue default continue button margin
  position: relative;

  a {
    display: flex;
    align-items: baseline;
    span {
      font-weight: 600;
      color: #106175;
      font-size: 18px;
      text-align: center;
    }
  }
}

.radio-button-section {
  height: 50%;
}
@media screen and (max-width: 992px) {
  .back-btn {
    margin-top: -4px !important;
    margin-left: -20px !important;
    margin-bottom: 10px !important;
  }
}
@media screen and (max-width: 640px) {
  .cover-help-block {
    width: 235px;
  }
}
@media screen and (max-width: $grid-breakpoints-md) {
  .radioImage.radio__wrapper {
    .img__wrapper {
      margin-bottom: 9px;
      min-height: auto;
      max-width: 91px;
    }
    .v-card {
      min-height: 144px !important;
      min-width: 134px !important;
    }

    .radioImage__inner label {
      line-height: 18px !important;
    }
  }

  .text--title.text-md-h4 {
    font-size: 28px !important;
  }
}
@media screen and (min-width: $grid-breakpoints-lg) {
  .rounded-lg.elevation-3 {
    margin-top: 30px !important;
    margin-bottom: 162px !important;
  }
  .continueBtn {
    margin-bottom: 144px !important;
  }
}
</style>
